import React, {useState, useEffect, useRef, useCallback, useMemo, memo} from 'react';
import {connect} from 'react-redux';
import DropDownOption from './subComponents/DropDownOption/DropDownOption';
import PurpleCheckmark from './assets/purpleCheckmark.svg';
import DropdownArrow from './assets/DropdownArrow.svg';

const MemoizedDropDownOption = memo(DropDownOption);

const CustomDashboardDropDown = ({
  controlText,
  options = [],
  onOptionSelect,
  initiallyOpen = false,
  defaultOption = null,
  onMenuOpenCallback,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(() => initiallyOpen);
  const [selectedOption, setSelectedOption] = useState(() => defaultOption);
  const dropdownRef = useRef(null);

  const canRenderDropDownMenu = isMenuOpen && options.length > 0;

  useEffect(() => {
    if (onOptionSelect && selectedOption) {
      onOptionSelect(selectedOption);
    }
  }, [selectedOption, onOptionSelect]);

  useEffect(() => {
    if (!isMenuOpen) return;

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  useEffect(() => {
    if (isMenuOpen){
      onMenuOpenCallback();
    }
  }, [isMenuOpen]);

  const isSelectedOption = useCallback((option) => {
      return option?.id === selectedOption?.id;
    },[selectedOption]);

  const handleControlSelect = useCallback(() => {
    setIsMenuOpen((prev) => !prev);
  }, []);

  const handleOptionSelect = useCallback((option) => {
      setIsMenuOpen(false);
      if (option?.id !== selectedOption?.id) {
        setSelectedOption(option);
      }
    },[selectedOption]);

  const controlTextDisplay = useMemo(() => {
    if (selectedOption?.id && selectedOption?.name) {
      return `${selectedOption.id} - ${selectedOption.name}`;
    }
    return controlText;
  }, [selectedOption, controlText]);

  const renderedOptions = useMemo(() => {
    if (!canRenderDropDownMenu) return null;

    return options.map((option, index) => {
      const selected = option?.id === selectedOption?.id;
      return (
        <MemoizedDropDownOption
          key={option?.id || index}
          text={`${option?.id} - ${option?.name}`}
          icon={selected ? PurpleCheckmark : null}
          grayBackgroundOnHover={!selected}
          notLastMenuElement={index < options.length - 1}
          onClick={() => handleOptionSelect(option)}
          isSelected={selected}
        />
      );
    });
  }, [options, selectedOption, canRenderDropDownMenu]);

  return (
    <div className='custom-business-dashboard-dropdown' ref={dropdownRef}>
      <div className='business-dashboard-select-control' onClick={handleControlSelect}>
        <MemoizedDropDownOption text={controlTextDisplay} icon={DropdownArrow} isMenuOpen={isMenuOpen} isSelected={true} />
      </div>

      {canRenderDropDownMenu && <div className='business-dashboard-dropdown-menu'>{renderedOptions}</div>}
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(CustomDashboardDropDown);
